document.addEventListener('DOMContentLoaded', function() {
  const hostname = window.location.hostname;

  document.querySelectorAll('a[href^="http"]').forEach(link => {
    const href = link.getAttribute('href');
    // 外部リンクの条件を定義
    const isExternal =
      !href.includes(hostname) &&
      !href.includes('myshopify.com') &&
      !href.startsWith('mailto:') &&
      !href.startsWith('tel:');

    if (isExternal) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});
